import React from 'react'
import { Usuario } from '../../model/Usuario'
import Action from '../../model/Action'

export function setUsuario(
    dispatch: React.Dispatch<Action>, payload: Usuario
) {
    dispatch({ type: 'setUsuario', payload })
}

export function setAuthenticated(
    dispatch: React.Dispatch<Action>, payload: boolean
) {
    dispatch({ type: 'setAuthenticated', payload })
}
